import * as weatherApi from './weather-api';
import { DEFAULT_FORECAST_DAYS, DEFAULT_HOURLY_FORECAST_NUM_HOURS } from '../constants';

/**
 * The "Weather Client" is a place for normalizing, error handling, logging, and tracking.
 */

export const setApiOrigin = weatherApi.setApiOrigin;

export function fetchDailyForecast(latitude, longitude, dayCount = DEFAULT_FORECAST_DAYS) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return weatherApi.fetchDailyForecast(latitude, longitude, dayCount);
}

export function fetchCurrentConditions(latitude, longitude) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return weatherApi.fetchCurrentConditions(latitude, longitude);
}

export function fetchAlerts(latitude, longitude) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return weatherApi.fetchAlerts(latitude, longitude);
}

export function fetchAlertDetails(alertKey) {
	return weatherApi.fetchAlertDetails(alertKey);
}

export function fetchHourlyForecast(latitude, longitude, hours = DEFAULT_HOURLY_FORECAST_NUM_HOURS) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return weatherApi.fetchHourlyForecast(latitude, longitude, hours).then(data => data.forecasts);
}

export function fetchTimeSeries(type, latitude, longitude, size) {
	if (!type || !latitude || !longitude || !size) {
		return Promise.reject('A required parameter is missing.');
	}

	return weatherApi.fetchTimeSeries(type, latitude, longitude, size);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/lib/weather-client.js